import './child-bio-details.scss';

import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';

import { ChildDetails } from '@sola/schema/dotcom/children/child.js';

import {
  key,
  templateString,
} from '../../organisms-cms/child-bio/utils/bioKeys';

export const ChildBioDetailsOverview = ({
  seoLevel = 1,
  details,
}: {
  seoLevel?: number;
  details: ChildDetails;
}) => {
  const { t } = useTranslation(['common', 'bio']);

  const CompContentHeading = `h${seoLevel + 2}` as ElementType;

  const translatedGrade = details.education.gradeLevel.us
    ?.replace('University Level', t('bio:universityLevel'))
    .replace('Preschool', t('bio:preschool'))
    .replace('Not Currently Enrolled', t('bio:notCurrentlyEnrolled'));
  let gradePerformance = t('bio:performanceAverage');
  if (details.education.academicPerformance?.toString() === 'Below Average') {
    gradePerformance = t('bio:performanceBelow');
  }
  if (details.education.academicPerformance?.toString() === 'Above Average') {
    gradePerformance = t('bio:performanceAbove');
  }
  if (details.education.academicPerformance?.toString() === 'Not Available') {
    gradePerformance = t('bio:performanceUnavailable');
  }
  const fathersJobKey = key(
    'bio:',
    details.householdList[0].maleGuardian.occupation || 'unknown',
  ).concat('_Male');
  const motherJobKey = key(
    'bio:',
    details.householdList[0].femaleGuardian.occupation || 'unknown',
  ).concat('_Female');
  return (
    <div>
      <CompContentHeading className="label-potent label-xl">
        {t('bio:schooling')}
      </CompContentHeading>
      <ul>
        <li>
          {t('bio:grade')}
          {translatedGrade}
        </li>
        <li>
          {t('bio:performance')}
          {gradePerformance}
        </li>
        <li>
          {details.education.notEnrolledInEducationReason
            ? t('bio:childNotAttending')
            : t('bio:childAttending')}
        </li>
      </ul>
      <CompContentHeading className="label-potent label-xl">
        {t('bio:familyDuties')}
      </CompContentHeading>
      <ul>
        {details.householdDuty?.map((item) => (
          <li key={item}>{t(templateString('bio:', item))}</li>
        ))}
      </ul>
      <CompContentHeading className="label-potent label-xl">
        {t('bio:hobbiesAndSports')}
      </CompContentHeading>
      <ul>
        {details.interests.thingsILike?.map((item) => (
          <li key={item}>{t(templateString('bio:', item))}</li>
        ))}
        {details.interests.favoriteProjectActivity?.map((item) => (
          <li key={item}>{t(templateString('bio:', item))}</li>
        ))}
      </ul>
      {details.householdList[0].householdMemberList &&
        details.householdList[0].householdMemberList?.length > 0 && (
          <>
            <CompContentHeading className="label-potent label-xl">
              {t('bio:familyInformation')}
            </CompContentHeading>
            <ul>
              <li>
                {t('bio:siblingsNumber')}
                {Number(details.householdList[0].siblings.numberOfBrothers) +
                  Number(details.householdList[0].siblings.numberOfSisters)}
              </li>
              <li>
                {t('bio:parentsMaritalStatus')}
                {t(
                  templateString(
                    'bio:relationship',
                    details.householdList[0].parents.maritalStatus || '',
                  ),
                )}
              </li>
              <li>
                {details.householdList[0].parents.naturalFather
                  .isLivingWithChild
                  ? t('bio:fatherWithChild')
                  : t('bio:fatherNotWithChild')}
              </li>
              <li>
                {details.householdList[0].parents.naturalMother
                  .isLivingWithChild
                  ? t('bio:motherWithChild')
                  : t('bio:motherNotWithChild')}
              </li>
            </ul>
            <CompContentHeading className="label-potent label-xl">
              {t('bio:guardians')}
            </CompContentHeading>
            <ul>
              <li>
                {t('bio:fatherEmployment')}
                {t(fathersJobKey as unknown as TemplateStringsArray)}
              </li>
              <li>
                {t('bio:fatherEmploymentStatus')}
                {details.householdList[0].maleGuardian.employmentStatus &&
                  t(
                    templateString(
                      'bio:employment',
                      details.householdList[0].maleGuardian.employmentStatus,
                    ),
                  )}
              </li>
              <li>
                {t('bio:motherEmployment')}
                {t(motherJobKey as unknown as TemplateStringsArray)}
              </li>
              <li>
                {t('bio:motherEmploymentStatus')}
                {details.householdList[0].femaleGuardian.employmentStatus &&
                  t(
                    templateString(
                      'bio:employment',
                      details.householdList[0].femaleGuardian.employmentStatus,
                    ),
                  )}
              </li>
            </ul>
          </>
        )}
    </div>
  );
};
